import { z } from "zod";

/** Whether reminder emails are going out, as the API decides it from configuration and the pause. */
export const NotificationEmailReminderEffectiveStateSchema = z.enum(["Sending", "Paused", "OffInConfiguration"]);

/** One reminder email's delivery state, as the API names it. */
export const NotificationEmailBatchStatusSchema = z.enum(["Pending", "Claimed", "Sent", "Retry", "Failed", "Cancelled"]);

const ActivitySchema = z.object({
  sentBatchCount: z.number(),
  cancelledBatchCount: z.number(),
  failedBatchCount: z.number(),
  retryingBatchCount: z.number(),
});

export const NotificationEmailReminderOperationsSchema = z.object({
  effectiveState: NotificationEmailReminderEffectiveStateSchema,
  configuration: z.object({
    enabled: z.boolean(),
    activationCutoffUtc: z.string().nullable(),
    defaultUnreadThresholdMinutes: z.number(),
    pollIntervalSeconds: z.number(),
    environment: z.string(),
  }),
  switch: z.object({
    isPaused: z.boolean(),
    pausedAtUtc: z.string().nullable(),
    reason: z.string().nullable(),
    changedBy: z.string().nullable(),
    changedAtUtc: z.string().nullable(),
  }),
  backlog: z.object({
    pendingCount: z.number(),
    oldestDueAtUtc: z.string().nullable(),
    activeBatchCount: z.number(),
    expiredLeaseCount: z.number(),
  }),
  last24Hours: ActivitySchema,
  last7Days: ActivitySchema,
  recentBatches: z.array(
    z.object({
      id: z.string(),
      recipient: z.string().nullable(),
      checkWindowUtc: z.string(),
      status: NotificationEmailBatchStatusSchema,
      attemptCount: z.number(),
      failureCode: z.string().nullable(),
      completedAtUtc: z.string().nullable(),
    }),
  ),
  recentChanges: z.array(
    z.object({
      paused: z.boolean(),
      reason: z.string().nullable(),
      changedBy: z.string().nullable(),
      changedAtUtc: z.string(),
      skippedReminderCount: z.number().nullable(),
    }),
  ),
});

export type NotificationEmailReminderEffectiveState = z.infer<typeof NotificationEmailReminderEffectiveStateSchema>;
export type NotificationEmailBatchStatus = z.infer<typeof NotificationEmailBatchStatusSchema>;
export type NotificationEmailReminderActivityJSON = z.infer<typeof ActivitySchema>;
export type NotificationEmailReminderOperationsJSON = z.infer<typeof NotificationEmailReminderOperationsSchema>;
